var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group"},[_vm._t("default",function(){return [_c('button',_vm._g(_vm._b({class:_vm._class,attrs:{"value":_vm.value}},'button',_vm.$attrs,false),_vm.listeners),[_vm._v(_vm._s(_vm.value))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }